import { render, staticRenderFns } from "./FormControlTypeTextarea.vue?vue&type=template&id=8c9046b0&scoped=true"
import script from "./FormControlTypeTextarea.vue?vue&type=script&lang=js"
export * from "./FormControlTypeTextarea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c9046b0",
  null
  
)

export default component.exports